import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const TopBoxessPage = Loader(
  lazy(() => import('content/pages/Private/TopBoxes')),
);

const RobotsPage = Loader(
  lazy(() => import('content/pages/Private/TopBoxes/Robots')),
);

const topboxesRouter: RouteObject[] = [
  {
    path: 'topboxes',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <TopBoxessPage />,
      },
      {
        path: 'robots',
        element: <RobotsPage />,
      },
    ],
  },
];

export default topboxesRouter;
